<template>
  <v-layout class="justify-center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on }">
        <div class="cursor-type flex justify-center" v-on="on">
          <slot></slot>
        </div>
      </template>
      <v-card>
        <v-card-title class="headline font-weight-black text-color-title">{{i18n(title)}}</v-card-title>
        <v-card-text>
          <span class="font-weight-medium color-text-literals">{{i18n('Há mais de um tipo de documento para pessoas físicas. Escolha um')}}:</span>
        </v-card-text>
        <v-card-actions>
          <v-layout class="row wrap">
            <v-flex class="flex-justify-between">
              <v-btn 
                v-for="document_type in document_types"
                v-bind:key="document_type"
                flat dark 
                class="secondary-bg-color mx-auto"
                @click="select(document_type)">{{document_type}}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'DocumentTypeSelectModal',
    props:{
      title: {
        type: String,
        default: "Seleção de documento"
      },
      document_types: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        dialog: true,
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
      select(option) {
        this.dialog = false
        this.$emit('select', option)
      },
    }
  }
</script>

<style scoped>
.secondary-bg-color{
  background-color: var(--secondary-button-background-color) !important;
}
.color-text-literals{
  color: rgba(46, 49, 49, 1) !important;
}
.text-color{
  color: var(--background-color) !important;
}
.text-color-title{
  color: #44517B  !important;
}
.cursor-type{
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex-justify-between{
  display: flex;
  justify-items: between;
}
</style>



// WEBPACK FOOTER //
// src/components/DocumentTypeSelectModal.vue